import api from './api';

const letterTemplateService = {
  async getTemplate(projectCode, letterKind) {
    const response = await api.get('/letter-templates', {
      params: {
        projectCode: projectCode || undefined,
        letterKind: letterKind || 'visit',
      },
    });
    return response.data;
  },

  async listForProject(projectCode) {
    const response = await api.get('/letter-templates/list', {
      params: { projectCode: projectCode || undefined },
    });
    return response.data;
  },

  async upsert(data) {
    const response = await api.put('/letter-templates', data);
    return response.data;
  },
};

export default letterTemplateService;
